/**
 * Controller: ProgramsCreateOrderModal
 */
angular.module('acme.view.application.programs.createOrderModal.controllers', [
  'acme.common.service.api',
  'acme.common.service.permissions',
  'acme.common.service.helpers',
  'acme.common.service.viewState'
])
.controller('ProgramsCreateOrderModalController', [ '$scope', '$filter', '$uibModalInstance', 'ApiService', 'PermissionsService', 'currentEvent', 'HelpersService', 'ViewStateService', function ($scope, $filter, $uibModalInstance, ApiService, PermissionsService, currentEvent, HelpersService, ViewStateService) {

    $scope.errors = [];

    $scope.filtered = [];

    $scope.model = {
      query: ViewStateService.getStateProperty('programs.create.order.modal.accounts', 'query', ''),
      selectedAccount: false,
      showPartners: false,
      limit: 40,
      incrementLimit: 40,
      createType: 'retail',
      partners: []
    };
    
    $scope.init = function() {
      $scope.$watch('model.createType', $scope.listeners.onModelCreateTypeUpdate);

      if (PermissionsService.check('ORDER_CREATE')) {
        // Do nothing already defaulted
      }else if (PermissionsService.check('ACCT_ORDERS_CREATE')) {
        $scope.model.createType = 'account';
      }else{
        $scope.model.createType = 'manual';
      }
    };

    $scope.hasPartners = function() {
      return ($scope.model.partners instanceof Array && $scope.model.partners.length > 0);
    };

    $scope.hasFiltered = function() {
      return ($scope.filtered instanceof Array && $scope.filtered.length > 0);
    };

    $scope.hasMore = function() {
      return ($scope.filtered.length > $scope.model.limit);
    };

    $scope.showMore = function() {
      $scope.model.limit += $scope.model.incrementLimit;
    };

    $scope.search = function() {
      $scope.model.limit = $scope.model.incrementLimit;
      $scope.filtered = $filter('filter')($scope.model.partners, function(partner) {
        var name = partner.company.name || '',
          value = (name).toLowerCase();

        return (value.indexOf($scope.model.query.toLowerCase()) !== -1) ? partner : null;
      });
    };

    $scope.listeners = {
      onModelCreateTypeUpdate: function(n, o) {
        if (n === 'account') {
          if (!$scope.hasPartners()) {
            ApiService.partners.list(HelpersService.getPaginator()).then($scope.handlers.success.getPartners, $scope.handlers.error.getPartners);
          }else{
            $scope.model.showPartners = true;
          }
        }else{
          $scope.errors = [];
          $scope.model.selectedAccount = '';
          $scope.model.showPartners = false;
        }
      }
    };
      
    $scope.handlers = {
      success: {
        getPartners: function(response) {
          $scope.model.partners = response.data.payload.list;
          $scope.model.showPartners = true;
          $scope.search();
          console.log('ProgramsCreateOrderModal::handlers::success::getPartners', $scope.model);
        }
      },
      error: {
        getPartners: function (response) {
          $scope.model.selectedAccount = '';
          $scope.model.showPartners = true;
          $scope.errors = [
            {
              message: response.data.error
            }
          ];
        }
      }
    };

    $scope.validate = function() {
      $scope.errors = [];

      if ($scope.model.createType === 'account') {
        if (!$scope.model.selectedAccount) {
          console.log('ProgramsCreateOrderModal::validate', (!$scope.model.selectedAccount));
          $scope.errors = [
            {
              message: 'You must select an account to continue.'
            }
          ];
        }
      }
      console.log('ProgramsCreateOrderModal::validate', $scope.errors);
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.validate();
      if (!$scope.hasErrors()) {
        ViewStateService.setState('programs.create.order.modal.accounts', {query: $scope.model.query});
        $scope.success();
      }
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close({
        type: $scope.model.createType,
        accountId: $scope.model.selectedAccount
      });
    };

    $scope.init();

  }]);